import React from 'react';
import { Logo } from './Logo';
const columns = [{
  title: 'Taskers',
  links: ['Browse tasks', 'How payouts work', 'Safety', 'Tasker FAQ']
}, {
  title: 'Companies',
  links: ['Post a task', 'Pricing', 'API', 'Enterprise']
}, {
  title: 'Company',
  links: ['About', 'Careers', 'Blog', 'Contact']
}];
export function Footer() {
  return <footer className="border-t border-line" data-id="element-47" data-mp="36ppk1ktg02bg">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-16 md:grid-cols-[1.5fr_repeat(3,1fr)]" data-id="element-48" data-mp="3ufa7afwmplqj">
        <div data-id="element-49" data-mp="3991alritibr">
          <Logo data-id="element-50" data-mp="38zaivynj750" />
          <p className="mt-4 max-w-xs text-sm text-muted" data-id="element-51" data-mp="37fun6gwqy3r">Location-specific micro-tasks, done by real people on the ground.</p>
        </div>
        {columns.map(col => <nav key={col.title} aria-label={col.title} data-id="element-52" data-mp="3qcnk4sawkozo">
            <h3 className="text-sm font-medium" data-id="element-53" data-mp="3qfjhaeexf9n2">{col.title}</h3>
            <ul className="mt-4 space-y-2.5" data-id="element-54" data-mp="29ydw5zakp29d">
              {col.links.map(link => <li key={link} data-id="element-55" data-mp="2ezbau1wdje64">
                  <a href="#" className="text-sm text-muted transition-colors duration-150 hover:text-ink" data-id="element-56" data-mp="2ezl4q0kji5h3">
                    {link}
                  </a>
                </li>)}
            </ul>
          </nav>)}
      </div>
      <div className="border-t border-line" data-id="element-57" data-mp="3v89d4bo4rpfa">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-6 py-6 text-xs text-muted sm:flex-row sm:justify-between" data-id="element-58" data-mp="3v919hopjxr6m">
          <p data-id="element-59" data-mp="3qazqf3s4lrv5">© 2026 LocalTask, Inc.</p>
          <p data-id="element-60" data-mp="828mc4dy418m">Privacy · Terms</p>
        </div>
      </div>
    </footer>;
}